// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ArrowLeftIcon = /* @__PURE__ */ createIcon(
  'arrow-left',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M11.293 4.293a1 1 0 1 1 1.414 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l5.293 5.293a1 1 0 1 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414z',
      },
    ],
  ]
);
